import { css } from 'styled-system/css';


export const toastStyle = {
	pushAside: css({
		base: {
			lg: {
				left: '50%',
				transform: 'translateX(calc( (-50% + (240px / 2))))',
			},
		}
	})
}